// Le bandeau du staging, dans l'en-tête (CDC 2026-10-09 § 4 ; décision des fondateurs du 12/10).
//
// Au staging (`staging.terobs.fr`), chaque en-tête porte une petite pastille « Staging » : la
// page ressemble au site public, mais c'est une copie anonymisée de la production, aucun
// courriel n'en part et les paiements Stripe y sont en mode test. Elle vit dans LienAccueil,
// le seul composant présent dans TOUS les en-têtes (vitrine, observatoire, intercommunalité,
// connexion) : un seul endroit, aucun en-tête oublié.
//
// La valeur vient d'une variable de BUILD, `VITE_ENVIRONNEMENT`, que `deploy/staging.sh`
// passe à `staging` ; la production est construite sans elle et n'affiche rien.
const ENVIRONNEMENT: string = import.meta.env.VITE_ENVIRONNEMENT ?? ''

const EXPLICATION =
  'Site de staging : copie anonymisée de la production, aucun courriel envoyé, ' +
  'paiements Stripe en mode test.'

export default function BadgeEnvironnement({ environnement = ENVIRONNEMENT }: { environnement?: string }) {
  if (environnement !== 'staging') return null
  return (
    <span
      className="ml-2 inline-flex items-center rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-xs font-semibold text-amber-800 whitespace-nowrap"
      title={EXPLICATION}
      data-environnement="staging"
    >
      Staging
    </span>
  )
}
